import Loader from "@/components/Loader";
import { routes } from "@/utils/constants";
import { getS3ImageUrl } from "@/utils/routes";
import Image from "next/image";
import Link from "next/link";
import { CSSProperties } from "react";
import classes from "./CategoryList.module.css";

interface Props {
  className?: string;
  style?: CSSProperties;

  categories: CategoryItem[];
  loading?: boolean;
}

const CategoryList = ({
  className,
  style,

  categories,
  loading,
}: Props) => {
  const classNames = [classes.CategoryList, className];

  return (
    <div className={classNames.join(" ")} style={style}>
      <div className={classes.list}>
        {categories.map((category) => {
          if (category.slug === "/") return null;

          return (
            <CategoryCard key={category.id + "-category-card"} item={category} />
          );
        })}
      </div>

      {loading && (
        <div className="absolute left-0 top-0 h-full w-full flex justify-center bg-white/70 py-14">
          <Loader size={64} />
        </div>
      )}

      {!loading && !categories.length && (
        <div className="text-center py-14">No category found!</div>
      )}
    </div>
  );
};

const CategoryCard = ({ item }: { item: CategoryItem }) => {
  return (
    <Link 
      href={routes.category + item.slug} 
      passHref
      className={`${classes.CategoryCard}`}
      style={{
        cursor: "pointer",
      }}
    >
      <div className={classes.top}>
        <Image
          src={getS3ImageUrl(item.logo || "")}
          alt={item.name?? 'category image'}
          blurDataURL={
            "https://www.unfe.org/wp-content/uploads/2019/04/SM-placeholder.png"
          }
          placeholder="blur"
          width={100}
          height={100}
          layout="responsive"
          objectFit="contain"
          className={classes.image}
          unoptimized={true}
          style={{
            aspectRatio: 1,
            objectFit: "contain",
          }}
        />
      </div>

      <div className={classes.bottom}>
        <h4 className={classes.title}>
          {item.name}
          <br />
          <br />
        </h4>
      </div>
    </Link>
  );
};

export default CategoryList;
